import React, { ReactElement, useEffect } from 'react';
import {
  Breadcrumbs, getTitle, homeBreadcrumb, setTitle,
} from 'slovlex-idsk-react-components';
import { Loader } from 'idsk-react-components';
import { useParams } from 'react-router';
import routes from '../../../routing/routes';
import Layout from '../../Layout';
import useDetailTerminu from '../../../module/DetailTerminu/hook/useDetailTerminu';
import GlobalErrors from '../../../module/GlobalErrors';
import PageHeadingWithBackButton from '../../../module/PageHeadingWithBackButton';
import SecuredPage from '../../../module/SecuredPage';
import UserRoleEnum from '../../../model/currentuser/UserRole';
import TerminCreateUpdate from '../../../module/Admin/Termin/CreateUpdate';

const AdminTerminUpdatePage = (): ReactElement => {
  const {
    tezaurusUuid,
    terminUuid,
  } = useParams<{ tezaurusUuid: string, terminUuid: string }>();
  const {
    termin,
    terminStatus,
  } = useDetailTerminu(terminUuid, true);

  useEffect(() => {
    if (!terminStatus?.loading) {
      setTitle(getTitle());
    }
  }, [terminStatus.loading]);

  return (
    <Layout>
      <>
        <Breadcrumbs routeList={[
          homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
          {
            to: routes.tezaurus.admin.list,
            heading: 'Administrácia tezaurov',
          },
          {
            to: routes.tezaurus.admin.termin.list.withParams(tezaurusUuid),
            heading: termin?.tezaurus?.nazov || 'Zoznam termínov',
          },
          {
            to: routes.tezaurus.admin.termin.detail.withParams(tezaurusUuid, terminUuid),
            heading: 'Úprava termínu',
          },
          {
            to: routes.tezaurus.admin.termin.edit.termin.withParams(tezaurusUuid, terminUuid),
            heading: 'Základné údaje',
          },
        ]}
        />
        <GlobalErrors />
        <SecuredPage
          allowForRoles={[UserRoleEnum.ADMINISTRATOR_TEZAURUS, UserRoleEnum.REDAKTOR_TEZAURUS]}
          requestStatus={terminStatus.responseCode}
        >
          <>
            <Loader loading={terminStatus?.loading}>
              {termin && (
                <>
                  <PageHeadingWithBackButton
                    heading={termin.preferovanyTermin}
                    headingCaption="Úprava termínu"
                  />
                  <TerminCreateUpdate
                    mode="UPDATE"
                    terminCurrent={
                      {
                        preferovanyTermin: termin.preferovanyTermin,
                        alternativnyTerminList: termin.alternativnyTerminList?.length > 0
                          ? termin.alternativnyTerminList
                            .map(alternativnyTermin => alternativnyTermin.alternativnyTermin) : [''],
                      }
                    }
                  />
                </>
              )}
            </Loader>
          </>
        </SecuredPage>
      </>
    </Layout>
  );
};
export default AdminTerminUpdatePage;
